export default function ChatBotUpArrowIco() {
  return (
    <svg
      width="151"
      height="34"
      viewBox="0 0 151 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
    >
      <g filter="url(#filter0_d_1240_194)">
        <path
          d="M28.1861 16.2988C21.5815 27.1742 11.9614 28.8412 5.26434 29L76 29L75.445 5L45.4469 5C40.424 5 33.8231 7.01672 28.1861 16.2988Z"
          fill="white"
        />
        <path
          d="M122.259 16.2988C128.863 27.1742 138.484 28.8412 145.181 29L75.2359 29L75 5L104.998 5C110.021 5 116.622 7.01671 122.259 16.2988Z"
          fill="white"
        />
      </g>
      <path
        d="M71 19.4995L76 14.4995L81 19.4995"
        stroke="#98A2B3"
        stroke-width="1.95524"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_1240_194"
          x="0.263672"
          y="0"
          width="149.916"
          height="34"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1240_194"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1240_194"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
